import React, { useState, useEffect } from 'react';
import { 
  Card, 
  Avatar, 
  Row, 
  Col, 
  Statistic, 
  Tabs, 
  List, 
  Button, 
  Tag,
  Space,
  message,
  Spin
} from 'antd';
import { 
  UserOutlined, 
  MailOutlined, 
  GithubOutlined,
  BookOutlined,
  HeartOutlined,
  EyeOutlined,
  EditOutlined,
  SettingOutlined,
  HistoryOutlined,
  StarOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { TabPane } = Tabs;

const About = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [myPosts, setMyPosts] = useState([]);
  const [favoritePosts, setFavoritePosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // 模拟加载数据
    setTimeout(() => {
      loadUserInfo();
      loadMyPosts();
      loadFavorites();
      setLoading(false);
    }, 500);
  }, []);

  const loadUserInfo = () => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      setUserInfo({
        ...user,
        stats: {
          posts: 12,
          views: 1543,
          likes: 284,
          comments: 89,
          joinedAt: '2023-01-15'
        },
        bio: '热爱技术，热爱生活，分享知识与思考',
        location: '中国',
        website: 'https://example.com'
      });
    }
  };

  const loadMyPosts = () => {
    setMyPosts([
      { id: '1', title: '我的第一篇博客', date: '2024-01-15', views: 156, likes: 24, tags: ['React', '学习'] },
      { id: '2', title: 'React学习笔记', date: '2024-01-10', views: 89, likes: 15, tags: ['React', '笔记'] },
      { id: '3', title: '技术分享', date: '2024-01-05', views: 45, likes: 8, tags: ['技术', '分享'] },
    ]);
  };

  const loadFavorites = () => {
    setFavoritePosts([
      { id: '4', title: '优秀的React教程', author: '张三', date: '2024-01-12', tags: ['React', '教程'] },
      { id: '5', title: '前端架构设计', author: '李四', date: '2024-01-08', tags: ['架构', '前端'] },
    ]);
  };

  const handleEditProfile = () => {
    message.info('编辑个人信息功能开发中');
  };

  const handleWritePost = () => {
    navigate('/write');
  };

  const handleViewPost = (postId) => {
    navigate(`/post/${postId}`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}年${month}月${day}日`;
  };

  if (loading) {
    return (
      <div className="about-loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="about-container">
      {/* 用户信息卡片 */}
      <Card className="profile-card">
        <div className="profile-header">
          <Avatar 
            size={120} 
            icon={<UserOutlined />} 
            src={userInfo?.avatar}
            className="profile-avatar"
          />
          <div className="profile-info">
            <h1 className="profile-name">{userInfo?.username || '未登录用户'}</h1>
            <p className="profile-bio">{userInfo?.bio || '热爱技术，热爱生活，分享知识与思考'}</p>
            <div className="profile-meta">
              <Space size="large">
                {userInfo?.location && (
                  <span className="meta-item">
                    <UserOutlined /> {userInfo.location}
                  </span>
                )}
                {userInfo?.stats?.joinedAt && (
                  <span className="meta-item">
                    <CalendarOutlined /> 加入于 {formatDate(userInfo.stats.joinedAt)}
                  </span>
                )}
              </Space>
            </div>
            <div className="profile-contact">
              {userInfo?.email && (
                <span className="contact-link">
                  <MailOutlined /> {userInfo.email}
                </span>
              )}
              {userInfo?.website && (
                <a href={userInfo.website} target="_blank" rel="noopener noreferrer" className="contact-link">
                  <SettingOutlined /> 个人网站
                </a>
              )}
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="contact-link">
                <GithubOutlined /> GitHub
              </a>
            </div>
            <div className="profile-actions">
              <Button 
                icon={<EditOutlined />} 
                onClick={handleEditProfile}
              >
                编辑资料
              </Button>
              <Button 
                type="primary" 
                icon={<EditOutlined />} 
                onClick={handleWritePost}
              >
                写文章
              </Button>
            </div>
          </div>
        </div>

        {userInfo && (
          <div className="profile-stats">
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={6} md={6}>
                <Statistic
                  title="文章数量"
                  value={userInfo.stats.posts}
                  prefix={<BookOutlined />}
                  className="stat-item"
                />
              </Col>
              <Col xs={12} sm={6} md={6}>
                <Statistic
                  title="总访问量"
                  value={userInfo.stats.views}
                  prefix={<EyeOutlined />}
                  className="stat-item"
                />
              </Col>
              <Col xs={12} sm={6} md={6}>
                <Statistic
                  title="总点赞数"
                  value={userInfo.stats.likes}
                  prefix={<HeartOutlined />}
                  className="stat-item"
                />
              </Col>
              <Col xs={12} sm={6} md={6}>
                <Statistic
                  title="评论数"
                  value={userInfo.stats.comments}
                  prefix={<HistoryOutlined />}
                  className="stat-item"
                />
              </Col>
            </Row>
          </div>
        )}
      </Card>

      {/* 个人中心内容卡片 */}
      <Card className="mine-content-card">
        <Tabs defaultActiveKey="posts">
          <TabPane 
            tab={
              <span>
                <BookOutlined />
                我的文章
              </span>
            } 
            key="posts"
          >
            <List
              dataSource={myPosts}
              renderItem={item => (
                <List.Item
                  actions={[
                    <Button type="link" onClick={() => handleViewPost(item.id)}>
                      查看
                    </Button>,
                    <Button type="link">
                      编辑
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    title={<a onClick={() => handleViewPost(item.id)}>{item.title}</a>}
                    description={
                      <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Space>
                          <span>发布时间: {item.date}</span>
                          <Tag color="blue">浏览量: {item.views}</Tag>
                          <Tag color="green">点赞: {item.likes}</Tag>
                        </Space>
                        <div className="post-tags">
                          {item.tags?.map(tag => (
                            <Tag key={tag} color="default" size="small">{tag}</Tag>
                          ))}
                        </div>
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
          </TabPane>

          <TabPane 
            tab={
              <span>
                <StarOutlined />
                我的收藏
              </span>
            } 
            key="favorites"
          >
            <List
              dataSource={favoritePosts}
              renderItem={item => (
                <List.Item
                  actions={[
                    <Button type="link" onClick={() => handleViewPost(item.id)}>
                      查看
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    title={<a onClick={() => handleViewPost(item.id)}>{item.title}</a>}
                    description={
                      <Space direction="vertical" size="small" style={{ width: '100%' }}>
                        <Space>
                          <span>作者: {item.author}</span>
                          <span>收藏时间: {item.date}</span>
                        </Space>
                        <div className="post-tags">
                          {item.tags?.map(tag => (
                            <Tag key={tag} color="default" size="small">{tag}</Tag>
                          ))}
                        </div>
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
          </TabPane>

          <TabPane 
            tab={
              <span>
                <SettingOutlined />
                个人设置
              </span>
            } 
            key="settings"
          >
            <div className="settings-section">
              <h3>账户设置</h3>
              <div className="settings-grid">
                <div className="setting-item">
                  <h4>基本信息</h4>
                  <Button>修改用户名</Button>
                  <Button>修改头像</Button>
                  <Button>修改个人简介</Button>
                </div>
                <div className="setting-item">
                  <h4>账户安全</h4>
                  <Button>修改密码</Button>
                  <Button>绑定邮箱</Button>
                  <Button>绑定手机</Button>
                </div>
                <div className="setting-item">
                  <h4>隐私设置</h4>
                  <Button>隐私保护</Button>
                  <Button>数据导出</Button>
                  <Button>注销账号</Button>
                </div>
              </div>
              {!userInfo && (
                <div className="login-prompt">
                  <p>请先登录以访问个人设置</p>
                  <Button type="primary" onClick={() => navigate('/auth')}>
                    立即登录
                  </Button>
                </div>
              )}
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default About;